import { RefObject } from 'react';
import RedesignImage from '../../../../shared/components/RedesignImage';
import { useBlockTypeMenuStyles } from './BlockTypeMenu.styles';

type BlockTypeMenuProps = {
  templateBlocks: any[];
  imgRef: RefObject<HTMLInputElement>;
  onSelectType: (blocTemplate: number) => void;
  onImageChange: (files: FileList | null) => void;
};

const BlockTypeMenu = ({
  templateBlocks,
  imgRef,
  onSelectType,
  onImageChange,
}: BlockTypeMenuProps) => {
  const classes = useBlockTypeMenuStyles();

  return (
    <div className={classes.blockTypeMenu}>
      <h3 className={classes.blockTypeMenuTitle}>
        Sélectionnez le type de bloc que vous souhaitez ajouter
      </h3>
      <input
        type="file"
        accept="image/*"
        ref={imgRef}
        className={classes.hiddenFileInput}
        onChange={event => onImageChange(event.target.files)}
      />
      <div className={classes.blockTypeGrid}>
        {templateBlocks?.map((block: any) => (
          <button
            key={block.id}
            type="button"
            className={classes.blockTypeItem}
            onClick={() => onSelectType(block.id)}>
            <RedesignImage
              src={block?.attributes?.img?.data?.attributes?.url}
              alt={block?.attributes?.name}
              className={classes.blockTypeImage}
              loading="lazy"
            />
            <span className={classes.blockTypeLabel}>{block?.attributes?.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default BlockTypeMenu;
